import React from "react";
import clsx from "clsx";

import { AccordionAnimation } from "~/components/Accordion/AccordionAnimation";
import { withFilterSection } from "./withFilterSection";

import { IconChevron } from "@bared/ui";

export const FilterSection = withFilterSection(
  ({ children, title, show, onClose, selectedCount }) => {
    return (
      <div className={clsx(show && "border-b", "w-full overflow-hidden")}>
        <div
          className="transition-presentation flex w-full items-center justify-start border-b hover:text-secondary"
          onClick={onClose}
        >
          <button className="grow px-mini py-maxi text-left">
            <span>{title}</span>
            <span className="ml-mini text-hint text-primary">
              {selectedCount}
            </span>
          </button>
          <IconChevron
            className={clsx(
              show && "rotate-180",
              "mx-mini mt-pico w-[12px] transform transform-gpu",
            )}
          />
        </div>
        <AccordionAnimation active={show}>{children}</AccordionAnimation>
      </div>
    );
  },
);
